import React from "react";
import { Box, Typography, Button as MuiButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./WelcomeBanner.module.scss";
import { ArrowForward } from "@mui/icons-material";

const WelcomeBanner: React.FC = () => {
    const navigate = useNavigate();

    const handleLearnMore = () => {
        navigate("/about");
    };

    return (
        <Box className={styles.welcomeBanner}>
            {/* <div className={styles.logoContainer}>
                <img
                    src="/MAX-Aspire-Logo.png"
                    alt="MAX Aspire Logo"
                    className={styles.logo}
                />
            </div> */}
            <Typography variant="h4" className={styles.title}>
                Welcome to MAX Aspire
            </Typography>
            <Typography variant="body1" className={styles.subtitle}>
                Connecting Muslim professionals around the World through meaningful networking,
                mentorship, and collaborative opportunities.
            </Typography>
            <MuiButton
                variant="contained"
                className={styles.learnMoreButton}
                onClick={handleLearnMore}
                endIcon={<ArrowForward />}
            >
                Learn More
            </MuiButton>
        </Box>
    );
};

export default WelcomeBanner;
